module.exports = __webpack_public_path__ + "img/pink-flower-card.7e791a9e.svg";